export default function cookieModalController(
    $scope,
    $timeout,
    $element,
    localStorageService,
    close,
    cookieFactory
) {
    $scope.showDetails = false;

    var currentCookieAllowance =
        localStorageService.cookie.get("cookieCompliance");

    $scope.cookieCategories = cookieFactory.initUserCategories(
        currentCookieAllowance
    ); // grap categories from Model -- also strips cookieCat.cookies array prop

    $scope.toggleCategory = function (category) {
        if (category.required) {
            console.warn("REQUIRED");
        } else {
            category.checked = !category.checked;
        }
    };

    $scope.toggleDetails = function () {
        $scope.showDetails = !$scope.showDetails;
    };

    $scope.userGrant = function (grant) {
        if (grant == "all") {
            angular.forEach($scope.cookieCategories, function (category) {
                category.checked = true;
            });
        }

        if (grant == "necessary") {
            angular.forEach($scope.cookieCategories, function (category) {
                if (!category.required) {
                    category.checked = false;
                }
            });
        }

        // IF "use selected" has been choosen - Continue as is (category object is changed when toggled)
        $timeout(function () {
            $scope.modalClose($scope.cookieCategories);
        }, 500);
    };

    /**
     * Close Modal (Promise to callback func)
     */
    $scope.modalClose = function (categories) {
        $element.modal("hide");

        close(categories, 500); // close, but give 500ms for bootstrap to animate
    };
}
